import { render, staticRenderFns } from "./itemPeriodo.vue?vue&type=template&id=f370c42a&scoped=true&"
import script from "./itemPeriodo.vue?vue&type=script&lang=js&"
export * from "./itemPeriodo.vue?vue&type=script&lang=js&"
import style0 from "./itemPeriodo.vue?vue&type=style&index=0&id=f370c42a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f370c42a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
